export default __webpack_public_path__ + "static/media/honeBeeHive.cf7d1e33.svg";